/// <reference path="../../app.definition.ts" />


import angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PopUpService } from "@common/popup/popup.service";
import { CacheService } from "@common/service/cache.service";
import { TeamInvitationService } from "@common/service/team.invitation.service";
import { UtilityService } from "@common/service/util.service";
import { TeamPermissionService } from "@common/service/teamPermission.service";
import { PaymentService } from "@common/service/payment.service";
import { PermissionService } from "ecv/common/permissions";
import { Util } from "@common/util";
import { TargetEnum, PermissionsEnum } from "@common/model/subject";
import { IAppRootScopeService } from "@/app/app.definition";


export class TeamService {
  joinTeam: Function;
  isUserCaptain: Function;
  sendInvitation: Function;
  openMemberProfile: Function;
  getSubjectwiseInviteInfo: Function;
  preCheckForInviteMember: Function;
  currentUser
  isDashboardCheck: Function;

  static $inject = ["ApiAdapterService", "PopUpService",
    "CacheService", "$q", "$state", "$rootScope", "TeamInvitationService", "UtilityService", "TeamPermissionService", "PaymentService", "PermissionService"];
  checkTransferOwnerRequestAlreadySent: (teamMember: any, subject: any, isExit: any) => angular.IPromise<unknown>;



  constructor(
    ApiAdapterService: JavaApiAdapterService,
    PopUpService: PopUpService,
    CacheService: CacheService,
    $q: angular.IQService,
    $state: angular.ui.IStateService,
    $rootScope: IAppRootScopeService,
    TeamInvitationService: TeamInvitationService,
    UtilityService: UtilityService,
    $_teamPerm: TeamPermissionService,
    PaymentService: PaymentService,
    PermissionService: PermissionService
  ) {
    // REVIEW
    this.currentUser = CacheService.getUser()
    this.joinTeam = (s) => {
      // join team by adding DOB of subject
      var deferred = $q.defer();
      ApiAdapterService.processInvitation(window.sessionStorage["ecvInvite"], s.value).then(
        (s) => {
          if (!window.sessionStorage["ecvInvite"]) {
            PopUpService.openInformationModal('The invitation has been successfully processed.').then(
              (s) => {
                CacheService.resetInviteInfo();
                deferred.resolve(s);
                if ($rootScope.glblNavDisabled) {
                  $state.go('parent-carefeed', {}, { reload: true, });
                } else {
                  $state.go($state.current, {}, { reload: true, });
                }
              }
            );
          } else {
            delete window.sessionStorage["ecvInvite"];
            CacheService.resetInviteInfo();
            deferred.resolve(s);
          }
        },
        (e) => {
          PopUpService.openInformationModal('Error while processing invitation.');
          delete window.sessionStorage["ecvInvite"];
          CacheService.resetInviteInfo();
          deferred.reject(e);
        });
      return deferred.promise;
    };

    this.isUserCaptain = (subjectId: any) => {
      // checks whether logged-in user is a captain or co-captain of the subject
      var deferred = $q.defer();
      ApiAdapterService.getSubject(subjectId, CacheService.getPassword()).then(
        (s) => {
          var subject = s;
          if (s.coCaptain || s.ownerId == CacheService.getUser().id) {
            deferred.resolve('sucess');
          } else {
            deferred.reject('error');
          }
        }
      );
      return deferred.promise;
    };

    this.sendInvitation = (user: any, subject: any) => {
      var deferred = $q.defer();
      var selectedTeam = subject;
      ApiAdapterService.getTeamMembers(subject.subjectId, null).then(
        (s) => {
          selectedTeam.currentTeamMembers = s;
          TeamInvitationService.inviteTeamMember(user, selectedTeam, null)
            .then(
              (s) => {
                if (s !== Util.DO_IT_LATER) {
                  deferred.resolve(s);
                }
                $rootScope.mainShowLoader = false;
              }, (e) => {
                console.log(e);
                user.providerIdentity = null;
                PopUpService.openInformationModal(e)
                $rootScope.mainShowLoader = false;
              });
        },
        (e) => {
          console.log("Error while sending invitation: " + e);
          deferred.reject(e);
        }
      );
      return deferred.promise;
    };

    this.openMemberProfile = (teammember) => {
      var subject = CacheService.getCurrentSubject();
      if (!subject.isFrozen) {
        var oldTeamMember = angular.copy(teammember);
        PopUpService.openMemberProfile(teammember, 'view', subject).then((s) => {
          teammember.invitationRecord.accepted = false;
        }, (e) => {
          teammember.deserialize(oldTeamMember);
        })
      }
    };

    this.getSubjectwiseInviteInfo = (subject): string => {
      let tooltipTxt = "Please make sure you have permission to add this person ";
      if (subject.subjectTypeId == 'INDIVIDUAL') {
        tooltipTxt += "to " + subject.firstName + "'s Team."
      } else if (subject.subjectTypeId == 'PROJECT') {
        tooltipTxt += "on the " + subject.projectName + " Project Team."
      }

      return tooltipTxt;
    }

    this.preCheckForInviteMember = (subject, redirectToBack: Function): any => {
      var deferred = $q.defer();
      let inviteMemberAllowed = true;
      let commonDocuments = [];
      let result = {
        inviteMemberAllowed: inviteMemberAllowed,
        commonDocuments: commonDocuments
      };
      this.isUserCaptain(subject.subjectId).then(
        (s: any) => {
          result['inviteMemberAllowed'] = false;
          let planType = CacheService.getUserPlanType();
          if (planType == 'ENTERPRISE') {
            ApiAdapterService.getAutoshareChecklist(subject.subjectId || subject.id).then(
              (s) => {

                for (var i = 0; i < s.length; i++) {
                  let ext = UtilityService.getFileExtension(s[i]);
                  let type = 'document';
                  if (ext.toLowerCase() == 'bmp' || ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'jpeg' || ext.toLowerCase() == 'gif') {
                    type = 'image';
                  }
                  let doc = {
                    fullName: s[i],
                    title: UtilityService.getFileName(s[i]),
                    extension: ext,
                    type: type,
                    sharedChecked: false
                  }
                  commonDocuments.push(doc);
                }
                result['commonDocuments'] = commonDocuments;
                deferred.resolve(result);
              }
            );
          }
          deferred.resolve(result);

        },
        // if user is not captain and trying to add member
        (e: any) => {
          // checking for new permissions 
          PermissionService.isActionAllowed(subject.teamPartyId, TargetEnum.TEAMMEMBER, PermissionsEnum.CREATE).then(isPermited => {
            if (isPermited) {
              // if its permited 
              result['inviteMemberAllowed'] = false;
              let planType = CacheService.getUserPlanType();
              if (planType == 'ENTERPRISE') {
                ApiAdapterService.getAutoshareChecklist(subject.subjectId || subject.id).then(
                  (s) => {
                    for (var i = 0; i < s.length; i++) {
                      let ext = UtilityService.getFileExtension(s[i]);
                      let type = 'document';
                      if (ext.toLowerCase() == 'bmp' || ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'jpeg' || ext.toLowerCase() == 'gif') {
                        type = 'image';
                      }
                      let doc = {
                        fullName: s[i],
                        title: UtilityService.getFileName(s[i]),
                        extension: ext,
                        type: type,
                        sharedChecked: false
                      }
                      commonDocuments.push(doc);
                    }
                    result['commonDocuments'] = commonDocuments;
                    deferred.resolve(result);
                  }
                );
              }
            } else {
              ApiAdapterService.getSubjectsTeamMembers([subject.subjectId]).then(data => {
                let members = data[subject.subjectId]
                const condition = (member) => member.id === this.currentUser.id;
                const isUserMember = members.some(condition)
                if (!isUserMember) {
                  redirectToBack();
                } else {
                  // else ther old flow 
                  result['inviteMemberAllowed'] = true;
                  // checking for DiscussionsAllowed
                  let isDiscAllowed = $_teamPerm.isDiscussionsAllowed(subject);

                  if (!isDiscAllowed) {
                    // if DiscussionsAllowed false then do this
                    PopUpService.openInformationModal(Util.NO_MODULE_TM_INVITE_MSG).then((s) => {
                      redirectToBack();
                    });
                  } else {
                    // if DiscussionsAllowed true then do this
                    PopUpService.openConfirmationModal(Util.TM_INVITE_MSG, "Start Discussion", "Not now").then(
                      (s) => {
                        PaymentService.checkLimitAndProceed("discussion", () => {
                          $state.go('connect', { ref: 'teams' });
                        });
                      },
                      (e) => {
                        redirectToBack();
                      }
                    );
                  }
                }
              })
              deferred.reject(result);
            }
          })

        }
      );

      return deferred.promise;
    }

    // validate if team owner transfer request already sent for selected subject
    this.checkTransferOwnerRequestAlreadySent = (teamMember, subject, isExit) => {
      var deferred = $q.defer();
      if (!subject.isFrozen) {
        var alreadyTransferedOwnership = false;
        var requestObject;
        ApiAdapterService.getTransferOwnershipRequest(subject.subjectId).then(
          (s) => {
            var ownershipRequestSent = s.sent;
            for (let req of ownershipRequestSent) {
              if (req.subjectId == subject.subjectId && req.status == 0) {
                alreadyTransferedOwnership = true;
                requestObject = req;
                break;
              }
            }

            if (alreadyTransferedOwnership) {
              //if transfer ownership request already sent
              PopUpService.ConfirmOwnershipModal(requestObject, 'alreadyTransferred');
              deferred.reject();
            } else {
              PopUpService.OpenTransferOwnershipModal(teamMember, subject, false, null, isExit).then(s => {
                deferred.resolve(true);
              }, (e) => {
                deferred.reject();
                console.log(e);
              });
            }
          },
          e => {
            console.log('error transfer request get');
            console.log(e);
            deferred.reject();
          }
        );
      }
      return deferred.promise;

    }
    this.isDashboardCheck = (subject) => {
      // if this.dashboard is false check subject permissions
      let isDashboard = CacheService.getFeatures().clientDashboard;

      if (!isDashboard) {
        // subject.userPerm
        if (!!subject.userPerm) {
          return subject.userPerm[TargetEnum.DASHBOARD][PermissionsEnum.LIST]
        }
      } else {
        this.currentUser = CacheService.getUser();
        if (this.currentUser && this.currentUser.organizationId === subject.teamOrgId) {
          return isDashboard
        }
        return false
      }

    }
  }
}

angular.module('eCareVault.common.services')
  .service('TeamService', TeamService);
